<template>
  <div class="top">
    <div class="top_center">
      <router-link to="/" class="top_logo"
        ><img src="@/assets/images/logo.png"
      /></router-link>
      <!--pc 端 导航 -->
      <nav-box />
    </div>
  </div>
</template>

<script>
import NavBox from "./component/NavBox";
export default {
  name: "Nav",
  components: {
    NavBox,
  },
  data() {
    return {};
  },
  created() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  width: 100%;
  display: block;
}
.top_center {
  width: 62.5%;
  height: 80px;
  display: block;
  margin: 0 auto;
  position: relative;
}
.top_logo {
  width: 170px;
  height: 72px;
  display: block;
  position: absolute;
  top: 5%;
  left: 0;
  overflow: hidden;
}
.top_logo > img {
  width: 100%;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@media only screen and (max-width: 1440px) {
  .top_center {
    width: 90%;
    height: 60px;
  }
}
@media only screen and (max-width: 425px) {
  .top_logo {
    width: 120px;
    height: 50px;
    top: 10%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar/index.vue